<template>
  <span class="viewsrhwxcommonComponent_waitAndReportShow">
    {{ textVal }}{{ timeCacl(item.create_time) }}
  </span>
</template>

<script>
import moment from "moment";
import socketListComputedMixin from "@/mixins/rh/socketListComputedMixin.js";
export default {
  name: "viewsrhwxcommonComponent_waitAndReportShow",

  props: ["item"],

  data() {
    return {
      textVal: ""
    };
  },

  computed: {},

  watch: {},

  components: {},

  mixins: [socketListComputedMixin],

  beforeRouteEnter(to, from, next) {
    next();
  },

  beforeRouteUpdate(to, from, next) {
    next();
  },

  beforeRouteLeave(to, from, next) {
    next();
  },

  beforeCreate() {},

  created() {
    this.calculationTime = moment();
    this.calculationTimeInterval = window.setInterval(() => {
      this.calculationTime = moment();
    }, 60000);
  },

  beforeMount() {},

  mounted() {
    this.$common
      .http({
        url: "/api/queue/config/queue",
        noLoading: true,
        data: {
          com_id: this.item.com_id
        }
      })
      .then(res => {
        if (res.data.data.queue_type == 1) {
          this.textVal = "已等待：";
        }
        if (res.data.data.queue_type == 2) {
          this.textVal = "已报道：";
        }
      });
  },

  beforeUpdate() {},

  updated() {},

  activated() {},

  deactivated() {},

  beforeDestroy() {},

  destroyed() {},

  errorCaptured() {},

  methods: {}
};
</script>
<style lang="less" scoped>
.viewsrhwxcommonComponent_waitAndReportShow {
}
</style>
<style lang="less">
.viewsrhwxcommonComponent_waitAndReportShow {
}
</style>
